(ns manage.content-variant-page.variant-feed.db
  (:require [clojure.string :as str]
            [common.datascript.util :as du]
            [datascript.core :as d]
            [manage.content-variant-page.placeholder.db
             :refer [find-placeholder-by-name targeting-key->placeholder-name]]
            [re-frame.core :as rf]
            [re-posh.core :as rp]))

(rf/reg-event-fx :variant-feed/import-keys
  (fn [_ [_ variant-feed-id]]
    {:fx [[:dispatch [:variant-feed/import-targeting-keys variant-feed-id]]
          [:dispatch [:variant-feed/import-optimizing-keys variant-feed-id]]]}))

(rf/reg-event-fx :variant-feed/import-unique-values
  [(rf/inject-cofx :ds)]
  (fn [{:keys [ds]} [_ [_ key-name]]]
    (let [key-type (->> (d/q '[:find ?kt :in $ ?kn
                               :where
                               [?k :variant-feed-key/name ?kn]
                               [?k :variant-feed-key/type ?kt]]
                             ds key-name)
                        (some first))]
      {:fx [(case key-type
              :targeting  [:dispatch [:targeting-key/import-targeting-values key-name]]
              :optimizing [:dispatch [:optimizing-key/import-optimizing-arms key-name]])]})))

(rf/reg-event-fx :variant-feed/import-targeting-keys
  [(rf/inject-cofx :ds)
   (rf/inject-cofx :sub :resource.feed-imports/field-classes)]
  (fn [{variant-feed-keys :resource.feed-imports/field-classes :keys [ds]} [_ variant-feed-id]]
    (let [vf [:variant-feed/id variant-feed-id]
          targeting-key? #(= (:class %) "targeting-key")
          targeting-key-names (sequence (comp (filter targeting-key?) (map :name)) variant-feed-keys)]
      {:fx (conj
            (for [targeting-key-name targeting-key-names]
              [:dispatch [:resource.content-variants/get-unique-values targeting-key-name]])
            [:transact (conj (du/sync-many
                              vf :variant-feed/variant-feed-key
                              (d/q '[:find ?k ?kn :in $ ?vf
                                     :where
                                     [?vf :variant-feed/variant-feed-key ?k]
                                     [?k :variant-feed-key/type :targeting]
                                     [?k :variant-feed-key/name ?kn]]
                                   ds vf)
                              targeting-key-names
                              (fn [targeting-key-name]
                                (let [p (find-placeholder-by-name ds (targeting-key->placeholder-name targeting-key-name))]
                                  (cond->
                                    {:variant-feed-key/name targeting-key-name
                                     :variant-feed-key/type :targeting}
                                    (some? p)
                                    (assoc :targeting-key/placeholder p)))))

                             {:variant-feed/id variant-feed-id})])})))

(defn find-placeholder-expression-by-value [ds value]
  (some (fn [[phe s]] (when (= value (first s)) phe))
        (d/q '[:find ?phe ?s :in $
               :where [?phe :singular-placeholder-expression/strings ?s]] ds)))

(rf/reg-event-fx :targeting-key/import-targeting-values
  [(rf/inject-cofx :ds)]
  (fn [{:keys [db ds]} [_ targeting-key-name]]
    (let [tk [:variant-feed-key/name targeting-key-name]
          tr-diffs (du/sync-many
                    tk :targeting-key/targeting-value
                    (d/q '[:find ?tv ?v :in $ ?tk
                           :where
                           [?tk :targeting-key/targeting-value ?tv]
                           [?tv :targeting-value/value ?v]]
                         ds tk)
                    (get-in db [:resource.content-variants/unique-values targeting-key-name])
                    (fn [value]
                      (let [phe (find-placeholder-expression-by-value ds value)]
                        (cond-> {:targeting-value/owner-id tk :targeting-value/value value}
                          (some? phe)
                          (assoc :targeting-value/placeholder-expression phe)))))]
      {:fx (cond-> []
             (not-empty tr-diffs)
             (conj [:transact tr-diffs]
                   [:dispatch [:variant-feed/sync-mapped-targeting-values->rules [:variant-feed/id "default"]]]))})))

(rp/reg-event-ds :variant-feed/sync-targeting-values->placeholder-expressions
  (fn [ds [_ vf]]
    (keep (fn [[tv value]]
            (when-let [phe (find-placeholder-expression-by-value ds value)]
              [:db/add tv :targeting-value/placeholder-expression phe]))
          (d/q '[:find ?tv ?value :in $ ?vf
                 :where
                 [?vf :variant-feed/variant-feed-key ?k]
                 [?k :targeting-key/targeting-value ?tv]
                 [?tv :targeting-value/value ?value]] ds vf))))

(rf/reg-event-fx :variant-feed/import-optimizing-keys
  [(rf/inject-cofx :ds)
   (rf/inject-cofx :sub :resource.feed-imports/field-classes)]
  (fn [{variant-feed-keys :resource.feed-imports/field-classes :keys [ds]} [_ variant-feed-id]]
    (let [vf [:variant-feed/id variant-feed-id]
          optimizing-key? #(= (:class %) "optimizing-key")
          optimizing-key-names (sequence (comp (filter optimizing-key?) (map :name)) variant-feed-keys)]
      {:fx (conj
            (for [optimizing-key-name optimizing-key-names]
              [:dispatch [:resource.content-variants/get-unique-values optimizing-key-name]])
            [:transact (du/sync-many
                        vf :variant-feed/variant-feed-key
                        (d/q '[:find ?k ?kn :in $ ?vf
                               :where
                               [?vf :variant-feed/variant-feed-key ?k]
                               [?k :variant-feed-key/type :optimizing]
                               [?k :variant-feed-key/name ?kn]]
                             ds vf)
                        optimizing-key-names
                        (fn [optimizing-key-name]
                          {:variant-feed-key/name optimizing-key-name
                           :variant-feed-key/type :optimizing}))])})))

(rf/reg-event-fx :optimizing-key/import-optimizing-arms
  [(rf/inject-cofx :ds)]
  (fn [{:keys [db ds]} [_ optimizing-key-name]]
    (let [ok [:variant-feed-key/name optimizing-key-name]
          tr-diffs (du/sync-many
                    ok :optimizing-key/optimizing-arm
                    (d/q '[:find ?oa ?v :in $ ?ok
                           :where
                           [?ok :optimizing-key/optimizing-arm ?oa]
                           [?oa :optimizing-arm/value ?v]]
                         ds ok)
                    (get-in db [:resource.content-variants/unique-values optimizing-key-name])
                    (fn [value]
                      {:optimizing-arm/owner-id ok :optimizing-arm/value value}))]
      {:fx (cond-> []
             (not-empty tr-diffs)
             (conj [:transact tr-diffs]))})))

(rp/reg-pull-sub :variant-feed/variant-feed-keys
  [{:variant-feed/variant-feed-key [:variant-feed-key/name :variant-feed-key/type :targeting-key/placeholder :db/id]}])

(rf/reg-sub :variant-feed/targeting-keys
  (fn [[_ vf]]
    (rf/subscribe [:variant-feed/variant-feed-keys vf]))
  (fn [{variant-feed-keys :variant-feed/variant-feed-key} _]
    (filter #(= (:variant-feed-key/type %) :targeting) variant-feed-keys)))

(rf/reg-sub :variant-feed/targeting-keys-missing-placeholder
  (fn [[_ vf]]
    (rf/subscribe [:variant-feed/targeting-keys vf]))
  (fn [targeting-keys _]
    (sequence (comp
               (remove :targeting-key/placeholder)
               (map :db/id))
              targeting-keys)))

(rf/reg-sub :targeting-key/targeting-values-as-string
  (fn [[_ tk]]
    (rf/subscribe [:ui.store/pull-entity [{:targeting-key/targeting-value [:targeting-value/value]}] tk]))
  (fn [{targeting-values :targeting-key/targeting-value} _]
    (->> targeting-values
         (sequence (comp
                    (take 20) ; since we truncate anyway, limit number of values for performance
                    (map :targeting-value/value)))
         (str/join " · "))))
